// eslint-disable-next-line no-unused-vars
const demoScanId = ['0831f777-cddd-4993-882e-47a03631b789', 'ac10ac53-186b-463b-a9f0-cd91ab16db67', '066bc668-5f58-4670-8759-7603ff7e2d5a'];
export default demoScanId;
